import Head from 'next/head';
import { ReactNode } from 'react';
import Script from 'next/script';
import { useSiteContext } from 'src/store';

type Props = {
  children: ReactNode;
  pageTitle?: string;
};

export const BaseLayout = (props: Props) => {
  const { children, pageTitle } = props;
  const { siteName, userTracking, seoConfiguration } = useSiteContext();
  const fullPageTitle = pageTitle ? `${pageTitle} - ${siteName}` : siteName;

  const hotJarUserTrackingDevice = userTracking?.find(
    (device) => device.deviceName.toUpperCase() === 'HOTJAR'
  );
  const isHotJarEnabled = hotJarUserTrackingDevice?.enabled;

  return (
    <>
      {fullPageTitle && (
        <Head>
          <title>{fullPageTitle}</title>
          <meta
            property="og:title"
            content={seoConfiguration?.title ?? fullPageTitle}
            key="title"
          />
          {seoConfiguration?.description && (
            <meta
              name="description"
              content={seoConfiguration.description}
              key="description"
            />
          )}
          {seoConfiguration?.keyWords && (
            <meta
              name="keywords"
              content={seoConfiguration.keyWords.join(', ')}
              key="keywords"
            />
          )}
        </Head>
      )}
      {children}
      {isHotJarEnabled && (
        <Script id="hotjar">
          {`(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (hotJarUserTrackingDevice.configuration as any).siteId
        },hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
        </Script>
      )}
    </>
  );
};

export default BaseLayout;
